import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  ApiGet,
  ApiPut,
  ApiDelete,
  ApiPost,
} from "../../../helpers/API/ApiData";
import { TailSpin } from "react-loader-spinner";
import { customStyles } from "../tableStyle";
import { toast } from "react-toastify";
import useDebounce from "../../../hooks/useDebounceHook";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "./winedervolage.scss";
import moment from "moment";
const Wiedervorlage = () => {
  const [filter, setFilter] = useState({ page: 1, countPerPage: 10, });
  const [startDate, setStartDate] = useState();
  const [sortFirma, setSortFirma] = useState();
  const [count, setCount] = useState(0);
  const [fileType, setfileType] = useState("");
  const [loading, setLoading] = useState(false);
  const [image, setimage] = useState("");
  const [close, setclose] = useState("");
  const [projectData, setProjectData] = useState({});
  const handleSortData = (sort, value) => {
    if (sort == "fsort") {

      setFilter((prev) => ({ ...prev, fsort: value }))
    } else {
      setFilter((prev) => ({ ...prev, wsort: value }))

    }

  };
  console.log(filter, "filterfilterfilter");
  const debouncedSearchValue = useDebounce(filter?.search, 900);
  const statusOption = [
    { label: "offen", value: "offen" },
    { label: "NICHT ERREICHT", value: "NICHT ERREICHT" },
    { label: "ZEITLICHE VERZÖGERUNG", value: "ZEITLICHE VERZÖGERUNG" },
    { label: "Termin", value: "Termin" },
    { label: "Vertragsverhandlung", value: "Vertragsverhandlung" },
    { label: "STORNO", value: "STORNO" },
    { label: "GEWONNEN", value: "GEWONNEN" },
  ];

  const customNoDataComponent = () => (
    <div style={{ textAlign: "center", padding: "10px 0px", fontSize: "16px" }}>
      Aktuell sind keine Daten vorhanden.
    </div>
  );
  const handleOnChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };
  const handleGenerateQuery = () => {
    let query = null;
    Object.entries(filter).map((item) => {
      query = `${query !== null ? query : ""}${item[1] ? (query ? "&" : "?") : ""
        }${item[1] ? item[0] + "=" + item[1] : ""}`;
    });
    return query;
  };
  const getUserData = async () => {
    setLoading(true);
    const query = handleGenerateQuery();
    await ApiGet(`vattenfall/wiedervorlagedata${query}`)
      .then((response) => {
        setProjectData(response?.data?.payload.leads);
        setLoading(false);
        setCount(response?.data?.payload?.pagination?.totalItems);
        // const activeData = data.filter((jobData) => {
        //   return jobData.roleId._id == "65fc2112e8fe93f708e798c3";
        // });
      })
      .catch((error) => {
        toast.error(error);
      });
  };
  useEffect(() => {
    getUserData();
  }, [debouncedSearchValue, filter]);
  console.log(`projectData`, projectData);
  const columns = [
    {
      name: "SNo",
      cell: (row, index) => {
        return <p>{(filter?.page - 1) * filter?.countPerPage + index + 1}</p>;
      },
      width: "60px",
    },
    {
      name: <span>Wiedervorlage</span>,
      width: "250px",
      selector: (row) => {
        // const statusClass = row?.status == "offen" || row?.status == "NICHT ERREICHT" || row?.status == "ZEITLICHE VERZÖGERUNG" ? "new-deisgnpppppppppp" : row?.status == "STORNO" ? "new-deisgn-statusooooooooooo" : "newstatusppppppppppp";

        return (
          <div>
            {row?.wiedervorlage
              ? moment(row.wiedervorlage).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      name: <span>Status</span>,
      width: "250px",
      selector: (row) => {
        const statusClass =
          row?.status == "offen" ||
            row?.status == "NICHT ERREICHT" ||
            row?.status == "ZEITLICHE VERZÖGERUNG"
            ? "new-deisgnpppppppppp"
            : row?.status == "STORNO"
              ? "new-deisgn-statusooooooooooo"
              : "newstatusppppppppppp";

        return (
          <div className={statusClass}>{row.status ? row.status : "-"}</div>
        );
      },
    },
    {
      name: (
        <>
          <span>Firma</span>
          <div className="sort-button">
            {filter?.fsort == "desc" ? (
              <div className="up-arrow" onClick={() => handleSortData("fsort", "asc")}>
                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4V20M12 4L8 8M12 4L16 8" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            ) : (
              <div className="down-arrow" onClick={() => handleSortData("fsort", "desc")} >
                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4V20M12 20L8 16M12 20L16 16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            )}
          </div>
        </>
      ),
      width: "250px",
      selector: (row) => {
        return (
          // <NavLink to={`/vattenlead?id=${row?._id}`} className="profileImage">
          row?.firma ? row?.firma : "-"
          // </NavLink>
        );
      },
    },
    {
      name: "Straße & Hausnummer",
      width: "250px",
      selector: (row) => (
        <div className="profileImage">{row.strabe ? row.strabe : "-"}</div>
      ),
    },

    {
      name: "Telefon",
      width: "250px",
      selector: (row) => (
        <div className="profileImage">{row.telephon ? row.telephon : "-"}</div>
      ),
    },

    {
      name: "Notizen",
      width: "250px",
      selector: (row) => (
        <div className="profileImage">{row.notizen ? row.notizen : "-"}</div>
      ),
    },
  ];
  return (
    <div>
      <div className="card p-1">
        <div className="p-2 mb-2">
          <div className="row mb-4 pr-3 " style={{ flexDirection: "column" }}>
            <div className="d-flex gap-20 Vattenfall-mobile-title vattenfall-title">
              <h2 className="pt-2 mr-5">Alle Leads</h2>

              <div className="header-items">
                <input
                  type="search"
                  className={`form-control form-control-lg form-control-solid `}
                  onChange={(e) => {
                    handleOnChangeFilter(e);
                    setLoading(true);
                  }}
                  name="search"
                  value={filter?.search}
                  placeholder="Suche"
                />
              </div>
              <div className="project-Dropdown project-Dropdown-sc">
                <Select
                  className="Select-main"
                  style={{ "zindex": "444444444444" }}
                  // menuIsOpen={true}
                  options={[
                    { label: "Ascending", value: "asc" },
                    { label: "Descending", value: "desc" },
                  ]}
                  onChange={(e) =>
                    handleOnChangeFilter({ target: { name: "sort", value: e } })
                  }
                  placeholder="Sort Date"
                  isClearable={true}
                />
              </div>

              <div className="project-Dropdown project-Dropdown-sc">
                <DatePicker
                  selected={startDate}
                  placeholderText="Date"

                  //   timeInputLabel="Time:"
                  onChange={(date) => {
                    setStartDate(date);
                    handleOnChangeFilter({
                      target: {
                        name: "date",
                        value: moment(date).format("YYYY-MM-DD"),
                      },
                    });
                  }}
                  // onKeyDown={(e) => e.preventDefault()}
                  // maxDate={new Date()}
                  //   showTimeInput
                  //   dateFormat="MM/dd/yyyy h:mm aa"
                  dateFormat="MM/dd/yyyy"
                  className="custom-date"
                />
              </div>
              <div className="project-Dropdown project-Dropdown-sc">
                <Select
                  isMulti
                  className="Select-main"
                  style={{ "zindex": "444444444444" }}
                  onChange={(e) =>
                    handleOnChangeFilter({
                      target: {
                        name: "status",
                        value: e.map((item) => item?.value).join(","),
                      },
                    })
                  }
                  options={statusOption}
                  placeholder="Status"
                  isClearable={true}
                />
              </div>
            </div>
          </div>
          <DataTable
            data={projectData}
            columns={columns}
            responsive
            noDataComponent={customNoDataComponent()}
            customStyles={customStyles}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={count}
            className="new_data__table table_height"
            paginationPerPage={filter?.countPerPage}
            paginationRowsPerPageOptions={[5, 10, 20, 25, 50]}
            paginationDefaultPage={filter?.page}
            progressPending={loading}
            progressComponent={
              <div className="LoadinComponent">
                <TailSpin color="#334D52" height={30} width={30} />
              </div>
            }
            onChangePage={(page) => {
              handleOnChangeFilter({ target: { name: "page", value: page } });
            }}
            onChangeRowsPerPage={(rowPerPage) => {
              handleOnChangeFilter({
                target: { name: "countPerPage", value: rowPerPage },
              });
            }}
            fixedHeader
          />
        </div>
      </div>

      {close && (
        <div className="new__imagemodel">
          <div className="body_model"></div>
          <div className="new-white-box">
            <div className="header_close">
              <i
                onClick={() => {
                  setclose(!close);
                  setimage("");
                }}
                className="fas fa-window-close modalClose"
              ></i>
            </div>
            <div className="image_body">
              {fileType == "svg" ||
                fileType == "png" ||
                fileType == "jpg" ||
                fileType == "jpeg" ? (
                <>
                  <img className="modal-image" src={image} />
                </>
              ) : fileType === "pdf" ? (
                <>
                  <object
                    data={image}
                    type="application/pdf"
                    width="420px"
                    height="650px"
                  ></object>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Wiedervorlage;
